module.exports = {"371524001":"铜城街道","371524002":"新城街道","371524101":"刘集镇","371524102":"牛角店镇","371524103":"大桥镇","371524104":"高集镇","371524105":"姜楼镇","371524107":"姚寨镇","371524108":"鱼山镇","371524205":"陈集乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371524.json
// module id = 1368
// module chunks = 0